// extracted by mini-css-extract-plugin
export var sliderRange = "_q6-2";
export var sliderRoot = "_q6-0";
export var sliderThumb = "_q6-3";
export var sliderTrack = "_q6-1";